import { render, staticRenderFns } from "./SustTables.vue?vue&type=template&id=127278cc&scoped=true"
import script from "./SustTables.vue?vue&type=script&lang=js"
export * from "./SustTables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127278cc",
  null
  
)

export default component.exports